export default {
  title: {
    id: 'bo_sellers_customer_care_open_tasks_no_request_found_block_surtitle',
    defaultMessage: 'Nothing to see here.',
  },
  defaultDescription: {
    id: 'bo_seller.customer_care.no_result_found_block_default_description',
    defaultMessage: 'No tasks, refunds or upcoming returns in sight.',
  },
}
